import { render, staticRenderFns } from "./brandstyle-slider.vue?vue&type=template&id=05c8c413&"
import script from "./brandstyle-slider.vue?vue&type=script&lang=js&"
export * from "./brandstyle-slider.vue?vue&type=script&lang=js&"
import style0 from "./brandstyle-slider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VRow,VSlider})
